import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import enOnboarding from "../locales/en/onboarding.json"
import esOnboarding from "../locales/es/onboarding.json"
import deOnboarding from "../locales/de/onboarding.json"
import daOnboarding from "../locales/da/onboarding.json"
import ptOnboarding from "../locales/pt/onboarding.json"
import itOnboarding from "../locales/it/onboarding.json"
import frOnboarding from "../locales/fr/onboarding.json"
import plOnboarding from "../locales/pl/onboarding.json"
import ukOnboarding from "../locales/uk/onboarding.json"
import ruOnboarding from "../locales/ru/onboarding.json"

// ENGLISH
import enSettings from "../locales/en/SettingsPage.json"
import enConversation from "../locales/en/ConversationSelector.json"
import enAudioSettings from "../locales/en/AudioSettings.json"
import enChatWindow from "../locales/en/ChatWindow.json"
import enTopMenu from "../locales/en/TopMenu.json"
import enHeroSection from "../locales/en/HeroSection.json"
import enTestimonials from "../locales/en/Testimonials.json"
import enFAQ from "../locales/en/FAQ.json"
import enFooter from "../locales/en/Footer.json"
import enLogin from "../locales/en/login.json"
import enSubscribe from "../locales/en/subscribe.json"
import enLanguageCarousel from "../locales/en/LanguageCarousel.json"
import enBenefits from "../locales/en/Benefits.json"
import enDailyGoalBar from "../locales/en/DailyGoalBar.json"
import enSwissHeroSection from "../locales/en/SwissHeroSection.json"
import enRosetVsGpt from "../locales/en/RosetVsGpt.json"
import enGeneralRosetVsGpt from "../locales/en/GeneralRosetVsGpt.json"
import enTrialExtension from "../locales/en/TrialExtension.json"
import enHowItWorks from "../locales/en/HowItWorks.json"
import enProductDemo from "../locales/en/ProductDemo.json"
import enPricing from "../locales/en/Pricing.json"
import enFinalCTA from "../locales/en/FinalCTA.json"
import enSocialProofBar from "../locales/en/SocialProofBar.json"

// SPANISH
import esSettings from "../locales/es/SettingsPage.json"
import esConversation from "../locales/es/ConversationSelector.json"
import esAudioSettings from "../locales/es/AudioSettings.json"
import esChatWindow from "../locales/es/ChatWindow.json"
import esTopMenu from "../locales/es/TopMenu.json"
import esHeroSection from "../locales/es/HeroSection.json"
import esTestimonials from "../locales/es/Testimonials.json"
import esFAQ from "../locales/es/FAQ.json"
import esFooter from "../locales/es/Footer.json"
import esLogin from "../locales/es/login.json"
import esSubscribe from "../locales/es/subscribe.json"
import esLanguageCarousel from "../locales/es/LanguageCarousel.json"
import esBenefits from "../locales/es/Benefits.json"
import esDailyGoalBar from "../locales/es/DailyGoalBar.json"
import esSwissHeroSection from "../locales/es/SwissHeroSection.json"
import esRosetVsGpt from "../locales/es/RosetVsGpt.json"
import esGeneralRosetVsGpt from "../locales/es/GeneralRosetVsGpt.json"
import esTrialExtension from "../locales/es/TrialExtension.json"
import esFinalCTA from "../locales/es/FinalCTA.json"
import esSocialProofBar from "../locales/es/SocialProofBar.json"

// GERMAN
import deSettings from "../locales/de/SettingsPage.json"
import deConversation from "../locales/de/ConversationSelector.json"
import deAudioSettings from "../locales/de/AudioSettings.json"
import deChatWindow from "../locales/de/ChatWindow.json"
import deTopMenu from "../locales/de/TopMenu.json"
import deHeroSection from "../locales/de/HeroSection.json"
import deTestimonials from "../locales/de/Testimonials.json"
import deFAQ from "../locales/de/FAQ.json"
import deFooter from "../locales/de/Footer.json"
import deLogin from "../locales/de/login.json"
import deSubscribe from "../locales/de/subscribe.json"
import deLanguageCarousel from "../locales/de/LanguageCarousel.json"
import deBenefits from "../locales/de/Benefits.json"
import deDailyGoalBar from "../locales/de/DailyGoalBar.json"
import deSwissHeroSection from "../locales/de/SwissHeroSection.json"
import deRosetVsGpt from "../locales/de/RosetVsGpt.json"
import deGeneralRosetVsGpt from "../locales/de/GeneralRosetVsGpt.json"
import deFinalCTA from "../locales/de/FinalCTA.json"
import deSocialProofBar from "../locales/de/SocialProofBar.json"

// Contact Form
import enContactForm from "../locales/en/ContactForm.json"
import esContactForm from "../locales/es/ContactForm.json"
import deContactForm from "../locales/de/ContactForm.json"
import daContactForm from "../locales/da/ContactForm.json"
import ptContactForm from "../locales/pt/ContactForm.json"
import itContactForm from "../locales/it/ContactForm.json"
import frContactForm from "../locales/fr/ContactForm.json"
import plContactForm from "../locales/pl/ContactForm.json"
import ukContactForm from "../locales/uk/ContactForm.json"
import ruContactForm from "../locales/ru/ContactForm.json"

// DANISH
import daSettings from "../locales/da/SettingsPage.json"
import daConversation from "../locales/da/ConversationSelector.json"
import daAudioSettings from "../locales/da/AudioSettings.json"
import daChatWindow from "../locales/da/ChatWindow.json"
import daTopMenu from "../locales/da/TopMenu.json"
import daHeroSection from "../locales/da/HeroSection.json"
import daTestimonials from "../locales/da/Testimonials.json"
import daFAQ from "../locales/da/FAQ.json"
import daFooter from "../locales/da/Footer.json"
import daLogin from "../locales/da/login.json"
import daSubscribe from "../locales/da/subscribe.json"
import daLanguageCarousel from "../locales/da/LanguageCarousel.json"
import daBenefits from "../locales/da/Benefits.json"
import daDailyGoalBar from "../locales/da/DailyGoalBar.json"
import daSwissHeroSection from "../locales/da/SwissHeroSection.json"
import daRosetVsGpt from "../locales/da/RosetVsGpt.json"
import daGeneralRosetVsGpt from "../locales/da/GeneralRosetVsGpt.json"
import daFinalCTA from "../locales/da/FinalCTA.json"
import daSocialProofBar from "../locales/da/SocialProofBar.json"

// PORTUGUESE
import ptSettings from "../locales/pt/SettingsPage.json"
import ptConversation from "../locales/pt/ConversationSelector.json"
import ptAudioSettings from "../locales/pt/AudioSettings.json"
import ptChatWindow from "../locales/pt/ChatWindow.json"
import ptTopMenu from "../locales/pt/TopMenu.json"
import ptHeroSection from "../locales/pt/HeroSection.json"
import ptTestimonials from "../locales/pt/Testimonials.json"
import ptFAQ from "../locales/pt/FAQ.json"
import ptFooter from "../locales/pt/Footer.json"
import ptLogin from "../locales/pt/login.json"
import ptSubscribe from "../locales/pt/subscribe.json"
import ptLanguageCarousel from "../locales/pt/LanguageCarousel.json"
import ptBenefits from "../locales/pt/Benefits.json"
import ptDailyGoalBar from "../locales/pt/DailyGoalBar.json"
import ptSwissHeroSection from "../locales/pt/SwissHeroSection.json"
import ptRosetVsGpt from "../locales/pt/RosetVsGpt.json"
import ptGeneralRosetVsGpt from "../locales/pt/GeneralRosetVsGpt.json"
import ptFinalCTA from "../locales/pt/FinalCTA.json"
import ptSocialProofBar from "../locales/pt/SocialProofBar.json"

// ITALIAN
import itSettings from "../locales/it/SettingsPage.json"
import itConversation from "../locales/it/ConversationSelector.json"
import itAudioSettings from "../locales/it/AudioSettings.json"
import itChatWindow from "../locales/it/ChatWindow.json"
import itTopMenu from "../locales/it/TopMenu.json"
import itHeroSection from "../locales/it/HeroSection.json"
import itTestimonials from "../locales/it/Testimonials.json"
import itFAQ from "../locales/it/FAQ.json"
import itFooter from "../locales/it/Footer.json"
import itLogin from "../locales/it/login.json"
import itSubscribe from "../locales/it/subscribe.json"
import itLanguageCarousel from "../locales/it/LanguageCarousel.json"
import itBenefits from "../locales/it/Benefits.json"
import itDailyGoalBar from "../locales/it/DailyGoalBar.json"
import itSwissHeroSection from "../locales/it/SwissHeroSection.json"
import itRosetVsGpt from "../locales/it/RosetVsGpt.json"
import itGeneralRosetVsGpt from "../locales/it/GeneralRosetVsGpt.json"
import itFinalCTA from "../locales/it/FinalCTA.json"
import itSocialProofBar from "../locales/it/SocialProofBar.json"

// FRENCH
import frSettings from "../locales/fr/SettingsPage.json"
import frConversation from "../locales/fr/ConversationSelector.json"
import frAudioSettings from "../locales/fr/AudioSettings.json"
import frChatWindow from "../locales/fr/ChatWindow.json"
import frTopMenu from "../locales/fr/TopMenu.json"
import frHeroSection from "../locales/fr/HeroSection.json"
import frTestimonials from "../locales/fr/Testimonials.json"
import frFAQ from "../locales/fr/FAQ.json"
import frFooter from "../locales/fr/Footer.json"
import frLogin from "../locales/fr/login.json"
import frSubscribe from "../locales/fr/subscribe.json"
import frLanguageCarousel from "../locales/fr/LanguageCarousel.json"
import frBenefits from "../locales/fr/Benefits.json"
import frDailyGoalBar from "../locales/fr/DailyGoalBar.json"
import frSwissHeroSection from "../locales/fr/SwissHeroSection.json"
import frRosetVsGpt from "../locales/fr/RosetVsGpt.json"
import frGeneralRosetVsGpt from "../locales/fr/GeneralRosetVsGpt.json"
import frTrialExtension from "../locales/fr/TrialExtension.json"
import frFinalCTA from "../locales/fr/FinalCTA.json"
import frSocialProofBar from "../locales/fr/SocialProofBar.json"

// POLISH
import plSettings from "../locales/pl/SettingsPage.json"
import plConversation from "../locales/pl/ConversationSelector.json"
import plAudioSettings from "../locales/pl/AudioSettings.json"
import plChatWindow from "../locales/pl/ChatWindow.json"
import plTopMenu from "../locales/pl/TopMenu.json"
import plHeroSection from "../locales/pl/HeroSection.json"
import plTestimonials from "../locales/pl/Testimonials.json"
import plFAQ from "../locales/pl/FAQ.json"
import plFooter from "../locales/pl/Footer.json"
import plLogin from "../locales/pl/login.json"
import plSubscribe from "../locales/pl/subscribe.json"
import plLanguageCarousel from "../locales/pl/LanguageCarousel.json"
import plBenefits from "../locales/pl/Benefits.json"
import plDailyGoalBar from "../locales/pl/DailyGoalBar.json"
import plSwissHeroSection from "../locales/pl/SwissHeroSection.json"
import plRosetVsGpt from "../locales/pl/RosetVsGpt.json"
import plGeneralRosetVsGpt from "../locales/pl/GeneralRosetVsGpt.json"
import plFinalCTA from "../locales/pl/FinalCTA.json"
import plSocialProofBar from "../locales/pl/SocialProofBar.json"

// UKRAINIAN
import ukSettings from "../locales/uk/SettingsPage.json"
import ukConversation from "../locales/uk/ConversationSelector.json"
import ukAudioSettings from "../locales/uk/AudioSettings.json"
import ukChatWindow from "../locales/uk/ChatWindow.json"
import ukTopMenu from "../locales/uk/TopMenu.json"
import ukHeroSection from "../locales/uk/HeroSection.json"
import ukTestimonials from "../locales/uk/Testimonials.json"
import ukFAQ from "../locales/uk/FAQ.json"
import ukFooter from "../locales/uk/Footer.json"
import ukLogin from "../locales/uk/login.json"
import ukSubscribe from "../locales/uk/subscribe.json"
import ukLanguageCarousel from "../locales/uk/LanguageCarousel.json"
import ukBenefits from "../locales/uk/Benefits.json"
import ukDailyGoalBar from "../locales/uk/DailyGoalBar.json"
import ukSwissHeroSection from "../locales/uk/SwissHeroSection.json"
import ukRosetVsGpt from "../locales/uk/RosetVsGpt.json"
import ukGeneralRosetVsGpt from "../locales/uk/GeneralRosetVsGpt.json"
import ukFinalCTA from "../locales/uk/FinalCTA.json"
import ukSocialProofBar from "../locales/uk/SocialProofBar.json"

// RUSSIAN
import ruSettings from "../locales/ru/SettingsPage.json"
import ruConversation from "../locales/ru/ConversationSelector.json"
import ruAudioSettings from "../locales/ru/AudioSettings.json"
import ruChatWindow from "../locales/ru/ChatWindow.json"
import ruTopMenu from "../locales/ru/TopMenu.json"
import ruHeroSection from "../locales/ru/HeroSection.json"
import ruTestimonials from "../locales/ru/Testimonials.json"
import ruFAQ from "../locales/ru/FAQ.json"
import ruFooter from "../locales/ru/Footer.json"
import ruLogin from "../locales/ru/login.json"
import ruSubscribe from "../locales/ru/subscribe.json"
import ruLanguageCarousel from "../locales/ru/LanguageCarousel.json"
import ruBenefits from "../locales/ru/Benefits.json"
import ruDailyGoalBar from "../locales/ru/DailyGoalBar.json"
import ruSwissHeroSection from "../locales/ru/SwissHeroSection.json"
import ruRosetVsGpt from "../locales/ru/RosetVsGpt.json"
import ruGeneralRosetVsGpt from "../locales/ru/GeneralRosetVsGpt.json"
import ruFinalCTA from "../locales/ru/FinalCTA.json"
import ruSocialProofBar from "../locales/ru/SocialProofBar.json"

// LearningPath
import enLearningPath from "../locales/en/LearningPath.json"
import esLearningPath from "../locales/es/LearningPath.json"
import deLearningPath from "../locales/de/LearningPath.json"
import daLearningPath from "../locales/da/LearningPath.json"
import ptLearningPath from "../locales/pt/LearningPath.json"
import itLearningPath from "../locales/it/LearningPath.json"
import frLearningPath from "../locales/fr/LearningPath.json"
import plLearningPath from "../locales/pl/LearningPath.json"
import ukLearningPath from "../locales/uk/LearningPath.json"
import ruLearningPath from "../locales/ru/LearningPath.json"

// ProgressReport
import enProgressReport from "../locales/en/ProgressReport.json"
import esProgressReport from "../locales/es/ProgressReport.json"

const supportedLangs = [
  "en",
  "es",
  "de",
  "da",
  "pt",
  "it",
  "fr",
  "pl",
  "uk",
  "ru",
]

const getInitialLang = () => {
  if (typeof window === "undefined") return "en"
  try {
    const stored = localStorage.getItem("appLang")
    const browser = navigator.language?.split("-")[0] || "en"

    if (supportedLangs.includes(stored)) return stored
    if (supportedLangs.includes(browser)) return browser
  } catch (error) {
    console.warn("Could not detect language:", error)
  }
  return "en"
}

// Initialize i18n unconditionally but with proper configuration
const resources = {
    en: {
      SettingsPage: enSettings,
      ConversationSelector: enConversation,
      AudioSettings: enAudioSettings,
      ChatWindow: enChatWindow,
      TopMenu: enTopMenu,
      HeroSection: enHeroSection,
      Testimonials: enTestimonials,
      FAQ: enFAQ,
      Footer: enFooter,
      login: enLogin,
      subscribe: enSubscribe,
      LanguageCarousel: enLanguageCarousel,
      Benefits: enBenefits,
      DailyGoalBar: enDailyGoalBar,
      Onboarding: enOnboarding,
      ContactForm: enContactForm,
      SwissHeroSection: enSwissHeroSection,
      RosetVsGpt: enRosetVsGpt,
      GeneralRosetVsGpt: enGeneralRosetVsGpt,
      TrialExtension: enTrialExtension,
      HowItWorks: enHowItWorks,
      ProductDemo: enProductDemo,
      Pricing: enPricing,
      FinalCTA: enFinalCTA,
      SocialProofBar: enSocialProofBar,
      LearningPath: enLearningPath,
      ProgressReport: enProgressReport,
    },
    es: {
      SettingsPage: esSettings,
      ConversationSelector: esConversation,
      AudioSettings: esAudioSettings,
      ChatWindow: esChatWindow,
      TopMenu: esTopMenu,
      HeroSection: esHeroSection,
      Testimonials: esTestimonials,
      FAQ: esFAQ,
      Footer: esFooter,
      login: esLogin,
      subscribe: esSubscribe,
      LanguageCarousel: esLanguageCarousel,
      Benefits: esBenefits,
      DailyGoalBar: esDailyGoalBar,
      Onboarding: esOnboarding,
      ContactForm: esContactForm,
      SwissHeroSection: esSwissHeroSection,
      RosetVsGpt: esRosetVsGpt,
      GeneralRosetVsGpt: esGeneralRosetVsGpt,
      TrialExtension: esTrialExtension,
      FinalCTA: esFinalCTA,
      SocialProofBar: esSocialProofBar,
      LearningPath: esLearningPath,
      ProgressReport: esProgressReport,
    },
    de: {
      SettingsPage: deSettings,
      ConversationSelector: deConversation,
      AudioSettings: deAudioSettings,
      ChatWindow: deChatWindow,
      TopMenu: deTopMenu,
      HeroSection: deHeroSection,
      Testimonials: deTestimonials,
      FAQ: deFAQ,
      Footer: deFooter,
      login: deLogin,
      subscribe: deSubscribe,
      LanguageCarousel: deLanguageCarousel,
      Benefits: deBenefits,
      DailyGoalBar: deDailyGoalBar,
      Onboarding: deOnboarding,
      ContactForm: deContactForm,
      SwissHeroSection: deSwissHeroSection,
      RosetVsGpt: deRosetVsGpt,
      GeneralRosetVsGpt: deGeneralRosetVsGpt,
      FinalCTA: deFinalCTA,
      SocialProofBar: deSocialProofBar,
      LearningPath: deLearningPath,
    },
    da: {
      SettingsPage: daSettings,
      ConversationSelector: daConversation,
      AudioSettings: daAudioSettings,
      ChatWindow: daChatWindow,
      TopMenu: daTopMenu,
      HeroSection: daHeroSection,
      Testimonials: daTestimonials,
      FAQ: daFAQ,
      Footer: daFooter,
      login: daLogin,
      subscribe: daSubscribe,
      LanguageCarousel: daLanguageCarousel,
      Benefits: daBenefits,
      DailyGoalBar: daDailyGoalBar,
      Onboarding: daOnboarding,
      ContactForm: daContactForm,
      SwissHeroSection: daSwissHeroSection,
      RosetVsGpt: daRosetVsGpt,
      GeneralRosetVsGpt: daGeneralRosetVsGpt,
      FinalCTA: daFinalCTA,
      SocialProofBar: daSocialProofBar,
      LearningPath: daLearningPath,
    },
    pt: {
      SettingsPage: ptSettings,
      ConversationSelector: ptConversation,
      AudioSettings: ptAudioSettings,
      ChatWindow: ptChatWindow,
      TopMenu: ptTopMenu,
      HeroSection: ptHeroSection,
      Testimonials: ptTestimonials,
      FAQ: ptFAQ,
      Footer: ptFooter,
      login: ptLogin,
      subscribe: ptSubscribe,
      LanguageCarousel: ptLanguageCarousel,
      Benefits: ptBenefits,
      DailyGoalBar: ptDailyGoalBar,
      Onboarding: ptOnboarding,
      ContactForm: ptContactForm,
      SwissHeroSection: ptSwissHeroSection,
      RosetVsGpt: ptRosetVsGpt,
      GeneralRosetVsGpt: ptGeneralRosetVsGpt,
      FinalCTA: ptFinalCTA,
      SocialProofBar: ptSocialProofBar,
      LearningPath: ptLearningPath,
    },
    it: {
      SettingsPage: itSettings,
      ConversationSelector: itConversation,
      AudioSettings: itAudioSettings,
      ChatWindow: itChatWindow,
      TopMenu: itTopMenu,
      HeroSection: itHeroSection,
      Testimonials: itTestimonials,
      FAQ: itFAQ,
      Footer: itFooter,
      login: itLogin,
      subscribe: itSubscribe,
      LanguageCarousel: itLanguageCarousel,
      Benefits: itBenefits,
      DailyGoalBar: itDailyGoalBar,
      Onboarding: itOnboarding,
      ContactForm: itContactForm,
      SwissHeroSection: itSwissHeroSection,
      RosetVsGpt: itRosetVsGpt,
      GeneralRosetVsGpt: itGeneralRosetVsGpt,
      FinalCTA: itFinalCTA,
      SocialProofBar: itSocialProofBar,
      LearningPath: itLearningPath,
    },
    fr: {
      SettingsPage: frSettings,
      ConversationSelector: frConversation,
      AudioSettings: frAudioSettings,
      ChatWindow: frChatWindow,
      TopMenu: frTopMenu,
      HeroSection: frHeroSection,
      Testimonials: frTestimonials,
      FAQ: frFAQ,
      Footer: frFooter,
      login: frLogin,
      subscribe: frSubscribe,
      LanguageCarousel: frLanguageCarousel,
      Benefits: frBenefits,
      DailyGoalBar: frDailyGoalBar,
      Onboarding: frOnboarding,
      ContactForm: frContactForm,
      SwissHeroSection: frSwissHeroSection,
      RosetVsGpt: frRosetVsGpt,
      GeneralRosetVsGpt: frGeneralRosetVsGpt,
      TrialExtension: frTrialExtension,
      FinalCTA: frFinalCTA,
      SocialProofBar: frSocialProofBar,
      LearningPath: frLearningPath,
    },
    pl: {
      SettingsPage: plSettings,
      ConversationSelector: plConversation,
      AudioSettings: plAudioSettings,
      ChatWindow: plChatWindow,
      TopMenu: plTopMenu,
      HeroSection: plHeroSection,
      Testimonials: plTestimonials,
      FAQ: plFAQ,
      Footer: plFooter,
      login: plLogin,
      subscribe: plSubscribe,
      LanguageCarousel: plLanguageCarousel,
      Benefits: plBenefits,
      DailyGoalBar: plDailyGoalBar,
      Onboarding: plOnboarding,
      ContactForm: plContactForm,
      SwissHeroSection: plSwissHeroSection,
      RosetVsGpt: plRosetVsGpt,
      GeneralRosetVsGpt: plGeneralRosetVsGpt,
      FinalCTA: plFinalCTA,
      SocialProofBar: plSocialProofBar,
      LearningPath: plLearningPath,
    },
    uk: {
      SettingsPage: ukSettings,
      ConversationSelector: ukConversation,
      AudioSettings: ukAudioSettings,
      ChatWindow: ukChatWindow,
      TopMenu: ukTopMenu,
      HeroSection: ukHeroSection,
      Testimonials: ukTestimonials,
      FAQ: ukFAQ,
      Footer: ukFooter,
      login: ukLogin,
      subscribe: ukSubscribe,
      LanguageCarousel: ukLanguageCarousel,
      Benefits: ukBenefits,
      DailyGoalBar: ukDailyGoalBar,
      Onboarding: ukOnboarding,
      ContactForm: ukContactForm,
      SwissHeroSection: ukSwissHeroSection,
      RosetVsGpt: ukRosetVsGpt,
      GeneralRosetVsGpt: ukGeneralRosetVsGpt,
      FinalCTA: ukFinalCTA,
      SocialProofBar: ukSocialProofBar,
      LearningPath: ukLearningPath,
    },
    ru: {
      SettingsPage: ruSettings,
      ConversationSelector: ruConversation,
      AudioSettings: ruAudioSettings,
      ChatWindow: ruChatWindow,
      TopMenu: ruTopMenu,
      HeroSection: ruHeroSection,
      Testimonials: ruTestimonials,
      FAQ: ruFAQ,
      Footer: ruFooter,
      login: ruLogin,
      subscribe: ruSubscribe,
      LanguageCarousel: ruLanguageCarousel,
      Benefits: ruBenefits,
      DailyGoalBar: ruDailyGoalBar,
      Onboarding: ruOnboarding,
      ContactForm: ruContactForm,
      SwissHeroSection: ruSwissHeroSection,
      RosetVsGpt: ruRosetVsGpt,
      GeneralRosetVsGpt: ruGeneralRosetVsGpt,
      FinalCTA: ruFinalCTA,
      SocialProofBar: ruSocialProofBar,
      LearningPath: ruLearningPath,
    },
}

// Initialize i18n - simple and synchronous
i18n.use(initReactI18next).init({
  resources,
  lng: typeof window !== "undefined" ? getInitialLang() : "en",
  fallbackLng: "en",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
